import React from "react";
import { FaArrowCircleUp, FaRobot } from "react-icons/fa";
import { TbMessageChatbot } from "react-icons/tb";

const BotList = ({ bots, onSelect, onCreate, onHandelClick }) => {
  return (
    <div className="flex flex-1 flex-col text-base text-gray-600  sm:px-10">
      {/* Heading */}
      <div className="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-end mb-6">
        <h1 className="text-4xl font-bold text-gray-800">AI Chatbots</h1>
        <div className="flex gap-3">
          <button
            onClick={onHandelClick}
            className="flex items-center gap-2 px-5 py-2 bg-darkprimary text-white rounded-lg hover:bg-gray-950 transition">
            <FaArrowCircleUp className="text-lg" />
            Unlock Pro
          </button>

          <button
            onClick={onCreate}
            className="flex items-center gap-2 px-5 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition">
            <FaRobot className="text-lg" />
            Create New Bot
          </button>
        </div>
      </div>

      {/* Bot List */}
      <ul className="grid grid-cols-1 sm:grid-cols-4 gap-6 text-gray-700">
        {bots && bots?.length === 0 ? (
          <p className="text-gray-500">No bots found. Create one!</p>
        ) : (
          bots?.map((bot, index) => (
            <li
              key={bot?.botId || index}
              onClick={() => onSelect(bot)}
              className="cursor-pointer group  flex flex-col  rounded-md border border-1 border-gray-200 transition">
              <div className="h-56 flex justify-center items-center bg-gray-200 group-hover:invert">
                <TbMessageChatbot size={100} />
              </div>
              <div className="p-3  bg-white group-hover:invert font-semibold   text-center">
                {bot?.botName}
              </div>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default BotList;
